import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";

import { Paper } from "@mui/material";
import Grid from "@mui/material/Grid";

import { useEffect } from "react";

import { CustomerSelect } from "@/features/customers";
import { AllOutletsSelect, OutletRoleEnum, UserOutletsSelect } from "@/features/outlets";
import { CustomDatePicker } from "@/features/ui";

export const GeneralInformationSection = ({ editMode = false }) => {
  const { control, watch, setValue } = useFormContext();

  const seller = watch("seller");
  const buyerableType = watch("buyerableType");

  const salesInvoicePayments = watch("salesInvoicePayments");

  // Disable buyer and seller when there are existing payments
  const disableBuyerSeller = salesInvoicePayments.length > 0;

  // Auto-set buyerableType based on seller's role
  useEffect(() => {
    if (seller) {
      const buyerableType =
        seller.role === OutletRoleEnum.HUB ? "OUTLET" : "CUSTOMER";
      setValue("buyerableType", buyerableType);
    }
  }, [seller, setValue]);

  useEffect(() => {
    if (editMode) return;

    if (buyerableType) {
      setValue("buyer", null);
    }
  }, [buyerableType, editMode, setValue]);

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, lg: 5 }}>
          <Controller
            control={control}
            name="buyer"
            render={({ field, fieldState }) =>
              buyerableType === "OUTLET" ? (
                <AllOutletsSelect
                  value={field.value}
                  onChange={field.onChange}
                  disabled={editMode || disableBuyerSeller}
                  allowedRoles={[OutletRoleEnum.RETAIL]}
                  TextFieldProps={{
                    label: "Pelanggan (Outlet Retail)",
                    required: true,
                    error: fieldState.invalid,
                    helperText: fieldState.error?.message,
                  }}
                />
              ) : (
                <CustomerSelect
                  value={field.value}
                  onChange={field.onChange}
                  disabled={editMode || disableBuyerSeller}
                  TextFieldProps={{
                    label: "Pelanggan (Retail)",
                    required: true,
                    error: fieldState.invalid,
                    helperText: fieldState.error?.message,
                  }}
                />
              )
            }
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            control={control}
            name="seller"
            render={({ field, fieldState }) => (
              <UserOutletsSelect
                value={field.value}
                onChange={field.onChange}
                disabled={editMode || disableBuyerSeller}
                allowedRoles={[OutletRoleEnum.HUB]}
                TextFieldProps={{
                  label: "Pemasok",
                  required: true,
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <Controller
            name="transactionDate"
            control={control}
            render={({ field, fieldState }) => (
              <CustomDatePicker
                value={field.value}
                onChange={field.onChange}
                required
                label="Tanggal Transaksi"
                error={fieldState.error}
                helperText={fieldState.error?.message}
                InputProps={{
                  disableFuture: true,
                }}
              />
            )}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  editMode: PropTypes.bool,
};
